//
//
//
//
//
//
//
//
//
//
//

import CommonList2 from "@/components/nav_common/CommonList2";
import { Author, Collection, Work } from "@/models";

export default {
  data() {
    return {
      // 查询到works的总数
      count: 0,
      selectOption: {
        name: "all",
        value: "",
      },
      conditions: [
        {
          name: "朝代",
          type: "dynasty",
          list: [
            // { text: '夏' },
            { text: "商" },
            { text: "周" },
            { text: "秦" },
            { text: "汉" },
            { text: "三国" },
            { text: "晋" },
            { text: "南北朝" },
            { text: "隋" },
            { text: "唐" },
            { text: "五代十国" },
            { text: "宋" },
            { text: "金" },
            { text: "元" },
            { text: "明" },
            { text: "清" },
            { text: "现代" },
          ],
        },
        {
          name: "体裁",
          type: "kind",
          list: [
            { kind: "shi", text: "诗" },
            { kind: "ci", text: "词" },
            { kind: "fu", text: "曲" },
            { kind: "wen", text: "文言文" },
          ],
        },
      ],
    };
  },

  props: {
    page: {
      type: Number,
      default: 1,
    },
    perPage: {
      type: Number,
      default: 10,
    },
  },

  watch: {
    page: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.getWorksData();
        }
      },
      immediate: false,
    },
  },

  components: {
    CommonList2,
  },

  created() {
    let promises = [];

    // 向data的condition里添加分类
    promises.push(
      Collection.getPartCollections().then((result) => {
        let collectCondition = { name: "分类", list: [], type: "collection" };
        let { list } = collectCondition;

        // 限制分类条目数位30条
        for (let i = 0; i < 30; i++) {
          let collection = result[i];

          list.push({
            text: collection.get("name"),
            collectionId: collection.id,
          });
        }

        // collectCondition.msg = "1,000,000 作品"

        this.conditions.unshift(collectCondition);
      })
    );

    // 向data的condition里添加作者
    promises.push(
      Author.getHotAuthors().then((result) => {
        // 截取数据存入data
        let authorCondition = { name: "作者", list: [], type: "author" };
        let { list } = authorCondition;

        result.forEach((author) => {
          list.push({
            check: false,
            text: author.get("name"),
            authorId: author.id,
          });
        });

        // authorCondition.msg = "30,000 作者"

        this.conditions.unshift(authorCondition);
      })
    );

    this.getAllWorks();
  },

  methods: {
    getWorksData() {
      let option = this.selectOption;
      let promise;

      switch (option.name) {
        case "author":
          promise = Work.getWorksIncludeCountByAuthor(
            option.value,
            this.page,
            this.perPage
          );
          break;
        case "collection":
          promise = Work.getWorksIncludeCountByCollection(
            option.value,
            this.page,
            this.perPage
          );
          break;
        case "kind":
          promise = Work.getWorksIncludeCountByKind(
            option.value,
            this.page,
            this.perPage
          );
          break;
        case "dynasty":
          promise = Work.getWorksIncludeCountByDynasty(
            option.value,
            this.page,
            this.perPage
          );
          break;
        case "all":
          promise = this.getAllWorks();
          return;
      }

      promise.then((result) => {
        this.emitCommon(result.works, result.pageCount);
      });
    },

    emitCommon(data, pageCount) {
      this.$emit("get-poetry-data", data);
      this.$emit("get-count", pageCount);
    },

    getAllWorks() {
      let page = this.page;

      // 53199
      if (this.page > 26599) {
        page -= 26599;
      }

      Work.getWorksAllIncludeCount(page, this.perPage).then((result) => {
        // pageCount 为本身查询到的数量 allwork大概是53199
        // 修改为10090
        this.emitCommon(result, 50045);
      });
    },

    // 四个不同的点击方法， 最后触发数据
    clickDynasty(dynasty) {
      if (dynasty !== this.selectOption.value) {
        this.selectOption.value = dynasty;
        this.selectOption.name = "dynasty";
        this.getWorksData();
        this.$emit("change-page", 1);
      }
    },

    clickAuthor(authorId) {
      if (authorId !== this.selectOption.value) {
        this.selectOption.value = authorId;
        this.selectOption.name = "author";
        this.getWorksData();
        this.$emit("change-page", 1);
      }
    },

    clickCollection(collectionId) {
      if (collectionId !== this.selectOption.value) {
        (this.selectOption.name = "collection"),
          (this.selectOption.value = collectionId);
        this.getWorksData();
        this.$emit("change-page", 1);
      }
    },

    // 体裁kind
    clickKind(kind) {
      if (kind !== this.selectOption.value) {
        (this.selectOption.name = "kind"), (this.selectOption.value = kind);
        this.getWorksData();
        this.$emit("change-page", 1);
      }
    },

    clickCondition(data, type) {
      // 根据type判断 选择了哪些
      switch (type) {
        case "dynasty":
          this.clickDynasty(data.text);
          break;
        case "author":
          this.clickAuthor(data.authorId);
          break;
        case "collection":
          this.clickCollection(data.collectionId);
          break;
        case "kind":
          this.clickKind(data.kind);
          break;
      }
    },

    // 如果点击了 “不限” 那么设置搜索选项为空
    clickUnlimit(type) {
      this.selectOption.name = "all";
      this.selectOption.value = "none";
      this.getWorksData();
      // 获取“不限制”作品，按照收藏数量排序
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/nav_poetry/PoetryClassList.vue